module.exports = __webpack_public_path__ + "img/300-box.f8944722.png";